<template>
  <TemplateModal class="22" ref="modal" center width="800" empty>
    <template v-slot:activator>
      <BaseTooltip
        :tooltip="localStorage.translations.pages['setting-personal_area'].sections['navyki']"
      >
        <button class="open" @click.stop.prevent="onOpenModal">
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_4150_4640)">
              <path
                d="M18.3784 13.7647H20.804C21.1197 14.6548 21.9697 15.2941 22.9666 15.2941C24.2316 15.2941 25.2607 14.265 25.2607 13C25.2607 11.735 24.2316 10.7059 22.9666 10.7059C21.9697 10.7059 21.1197 11.3452 20.804 12.2353H18.3784V3.05881H20.804C21.1197 3.94887 21.9697 4.58822 22.9666 4.58822C24.2316 4.58822 25.2607 3.55903 25.2607 2.2941C25.2607 1.02913 24.2316 -1.52588e-05 22.9666 -1.52588e-05C21.9697 -1.52588e-05 21.1197 0.63933 20.804 1.5294H16.8489V12.2353H14.6058V9.99214C14.6058 7.85576 12.8677 6.11763 10.7313 6.11763H7.67247H4.61365C2.47721 6.11763 0.739136 7.85576 0.739136 9.99214V16.8235H3.08423V10.451H4.61365V26H6.90776V17.5882H8.43718V26H10.7313V10.451H12.2607V16.8235H14.6058V13.7647H16.8489V24.4706H20.804C21.1197 25.3606 21.9697 26 22.9666 26C24.2316 26 25.2607 24.9709 25.2607 23.7059C25.2607 22.4409 24.2316 21.4117 22.9666 21.4117C21.9697 21.4117 21.1197 22.0511 20.804 22.9412H18.3784V13.7647Z"
                fill="#F2994A"
              />
              <path
                d="M7.67247 6.11763C9.36181 6.11763 10.7313 4.74815 10.7313 3.05881C10.7313 1.36947 9.36181 -1.52588e-05 7.67247 -1.52588e-05C5.98313 -1.52588e-05 4.61365 1.36947 4.61365 3.05881C4.61365 4.74815 5.98313 6.11763 7.67247 6.11763Z"
                fill="#F2994A"
              />
            </g>
            <defs>
              <clipPath id="clip0_4150_4640">
                <rect width="26" height="26" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </BaseTooltip>
    </template>
    <Skills
      :skills="works"
      :employeeId="employeeId"
      :editing="
        $userCheckAccess({
          abilities: 'edit_employees',
        })
      "
      modal
      :onDownloadPageData="onDownloadPageData"
    />
  </TemplateModal>
</template>

<script>
import { mapActions } from 'vuex'
import Skills from 'components/personalArea/Skills'

export default {
  name: 'EmployeeWorkTypesModal',
  props: {
    employeeId: [String, Number],
    works: Array,
    onDownloadPageData: Function,
  },
  components: { Skills },
  data: () => ({}),
  computed: {
    modalShow() {
      return this.$refs.modal && this.$refs.modal.dialog
    },
  },
  watch: {
    modalShow() {
      if (!this.modalShow) {
        this.offNavigationGuardianCheck()
      }
    },
  },
  methods: {
    ...mapActions('workClientProjectsSubscribers', ['onWorkClientProjectsSubscribersDelete']),
    ...mapActions('navigationGuardian', ['offNavigationGuardianCheck']),
    onOpenModal() {
      this.$refs.modal.openModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.open {
  width: max-content;
  height: max-content;
  position: relative;
  transition: 0.3s;
  .circle {
    position: absolute;
    left: 70%;
    bottom: -10%;
    &::before {
      background: #ffffff;
      border-radius: 50%;
      min-width: 15px;
      content: attr(data-text);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-size: 10px;
      padding: 3px;
      color: #277faf;
    }
  }
  &:hover {
    svg {
      filter: brightness(0.5);
    }
  }
}
form {
  display: block !important;
  .skills {
    width: 100%;
  }
}
</style>
